import React, { Component } from 'react';
import { ContextProvider } from './Context';
import { CssBaseline } from '@material-ui/core';
import { StripeProvider } from 'react-stripe-elements';
import Router from './Components/Router';
import config from './Config/config';

export default class App extends Component {
	render() {
		return (
			<div>
				<CssBaseline />
				<ContextProvider>
					<StripeProvider apiKey={config.STRIPE_PK}>
						<Router />
					</StripeProvider>
				</ContextProvider>
			</div >
		);
	}
}

